import { SKIN_BACKGROUND, SKIN_BACKGROUND_DARK } from './colorUtils'
import { isDarkMode } from './configUtils'

export function createDefs(root) {
  let defs = root.selectAll('defs').data([null], (d, i) => i)
  const defsEnter = defs.enter().append('defs')
  defs = defs.merge(defsEnter)
  return defs
}

function convertSvgToPattern(id, svg, color) {
  let patternString = svg.replace('<svg', '<pattern')
  patternString = patternString.replace('</svg>', '</pattern>')
  patternString = patternString.replace(/fill="[^"]*"/g, '')

  const parser = new DOMParser()
  const patternElement = parser
    .parseFromString(patternString, 'image/svg+xml')
    .querySelector('pattern')

  patternElement.removeAttribute('viewBox')
  patternElement.setAttribute('patternUnits', 'userSpaceOnUse')
  patternElement.setAttribute('id', id)
  patternElement.setAttribute('fill', 'white')
  patternElement.setAttribute('height', '48px')
  patternElement.setAttribute('width', '48px')

  // Add a background rectangle
  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
  rect.setAttribute('width', '100%')
  rect.setAttribute('height', '100%')
  rect.setAttribute('fill', color)
  patternElement.insertBefore(rect, patternElement.firstChild)
  return patternElement
}

export function addPatterns(context, items) {
  const defs = createDefs(context.root)

  const uniquePatterns = Object.values(
    items.reduce((accumulator, current) => {
      const keys = Object.keys(accumulator)
      if (current.pattern) {
        const patternKey = getPatternId(current.pattern.id, current.color)
        if (!keys.includes(patternKey))
          accumulator[patternKey] = { patternId: patternKey, ...current }
      }
      return accumulator
    }, {})
  )
  //const patternElement = convertSvgToPattern(plusPatternId, plusPattern)
  let pattern = defs.selectAll('pattern').data(uniquePatterns, d => d.patternId)
  const patternEnter = pattern
    .enter()
    .append(d => convertSvgToPattern(d.patternId, d.pattern.svg, d.color))

  pattern.exit().remove()
  pattern = pattern.merge(patternEnter)

  pattern.attr(
    'fill',
    isDarkMode(context.config, context._parent.accessibilityOptions)
      ? SKIN_BACKGROUND_DARK
      : SKIN_BACKGROUND
  )

  /*
    const mask = `<mask id="${plusPatternId}-mask" x="0" y="0" width="1" height="1">
      <rect x="0" y="0" width="100%" height="100vh" fill="url(#${plusPatternId})" fill-opacity="1"></rect>
    </mask>
    `
    */
  /*
  let masks = defs.selectAll('mask').data(
    uniquePatterns.map(p => p.id),
    d => d
  )
  const masksEnter = masks
    .enter()
    .append('mask')
    .attr('id', d => `${d}-mask`)
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 1)
    .attr('height', 1)
  masksEnter
    .append('rect')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', '100vw')
    .attr('height', '100vh')
    .attr('fill', d => `url(#${d})`)

  masks.exit().remove()
  masks = masks.merge(masksEnter)
  */
}

export function getPatternId(id, color) {
  if (!color) return null
  return btoa(`${id}-${color.replace('#')}`)
}
